import {animate, state, style, transition, trigger} from '@angular/animations';
import {Component, EventEmitter, Inject, Input, OnInit, Output, OnChanges} from '@angular/core';
import {MOMENT_TOKEN} from '../../../../../shared/shared.module';
import {SiteService} from 'src/app/+home/+my-libraries/shared/services/site.service';

@Component({
  selector: 'app-display-search-results',
  templateUrl: './display-search-results.component.html',
  styleUrls: ['./display-search-results.component.scss'],
  animations: [
    trigger('fade', [
      state('void', style({
        opacity: 0,
      })),
      transition(':enter',
        animate(300)
      )
    ])
  ]
})
export class DisplaySearchResultsComponent implements OnInit, OnChanges {
  @Input() searchSite: string;
  @Input() searchTerm: string;
  @Input() results;
  @Input() totalResults: number;
  @Input() search: string;
  @Input() loading: boolean;
  @Input() hideNumberItems = false;
  @Output() clickFileName = new EventEmitter();
  @Output() clickFile = new EventEmitter();

  constructor(@Inject(MOMENT_TOKEN) public moment, private siteService: SiteService) {
  }

  ngOnInit() {

  }

  ngOnChanges() {
    this.results.forEach((el) => {
      if (!el.isArticle && el.path.elements[el.path.elements.length - 1].name === 'documentLibrary') {
        this.siteService.getOne(el.path.elements[el.path.elements.length - 2].name).then((res) => {
          el.parent = res.title;
        });
      }
    });
  }
}
